'use client';

import styles from './TermsAndConditions.module.css';
import { useTranslation } from 'next-i18next';
interface TermsAndConditionsProps {
  className?: string;
  text?: string;
}

export default function TermsAndConditions({
  className = '',
  text = 'Terms & Conditions',
}: TermsAndConditionsProps) {
  const { t } = useTranslation();
  const handleClick = () => {
    window.open(
      'https://qrhunt.pifsaudiintlgolf.com/terms',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <button
      className={`${styles.termsLink} ${className}`}
      onClick={handleClick}
      type="button"
      title="View Terms & Conditions"
      aria-label="View Terms & Conditions"
    >
      {t(text)}
    </button>
  );
}
